document.addEventListener('DOMContentLoaded', function () {
if (typeof Swiper !== 'undefined' && document.querySelector('.pdp_slider') && document.querySelector('.pdp_thumb_slider')) {
  var thumbSwiper = new Swiper('.pdp_thumb_slider', {
    slidesPerView: 3,
    spaceBetween: 5,
    grabCursor: true,
    loop: false,
    speed: 600,
    direction: 'vertical',
    watchSlidesProgress: true,
    breakpoints: {
      300: {
        direction: 'horizontal',
        slidesPerView: 4,
      },
      576: {
        direction: 'horizontal',
        slidesPerView: 6,
      },
      992: {
        direction: 'vertical',
        slidesPerView: 9,
      },
    },
  });

  var mainSwiper = new Swiper('.pdp_slider', {
    slidesPerView: 1,
    spaceBetween: 10,
    grabCursor: true,
    speed: 600,
    loop: false,
    navigation: {
      nextEl: '.pdp_slider .pdp_slider_next',
      prevEl: '.pdp_slider .pdp_slider_prev',
    },
    autoplay: {
      delay: 8000,
      pauseOnMouseEnter: true,
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  });
}
$(document).ready(function () {
  $("#topbar_slider").owlCarousel({
    items: 1,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    dots: false,
    nav: true,
    navText: ["<i class='bi bi-chevron-left'></i>", "<i class='bi bi-chevron-right'></i>"]
  });
  $("#herbalist_slider").owlCarousel({
    items: 4,
    margin: 20,
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 2000,
    autoplayHoverPause: true,
    dots: false,
    nav: false,
    navText: ["<i class='bi bi-chevron-left'></i>", "<i class='bi bi-chevron-right'></i>"],
    responsive: {
      0: {
        items: 1,
        stagePadding: 60
      },
      576: {
        items: 1,
        stagePadding: 150
      },
      768: {
        items: 2,
        stagePadding: 100
      },
      992: {
        items: 2,
        stagePadding: 300
      }
    }
  });
  $("#social_slider").owlCarousel({
    items: 4,
    margin: 20,
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 2000,
    autoplayHoverPause: true,
    dots: false,
    nav: false,
    navText: ["<i class='bi bi-chevron-left'></i>", "<i class='bi bi-chevron-right'></i>"],
    responsive: {
      0: {
        items: 1,
        stagePadding: 60
      },
      576: {
        items: 2,
        stagePadding: 150
      },
      768: {
        items: 3,
        stagePadding: 100
      },
      992: {
        items: 5,
        stagePadding: 300
      }
    }
  });
  $("#social_slider2").owlCarousel({
    items: 4,
    margin: 20,
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 800,
    autoplayHoverPause: true,
    dots: false,
    nav: false,
    navText: ["<i class='bi bi-chevron-left'></i>", "<i class='bi bi-chevron-right'></i>"],
    responsive: {
      0: {
        items: 1,
        stagePadding: 60
      },
      576: {
        items: 2,
        stagePadding: 150
      },
      768: {
        items: 3,
        stagePadding: 100
      },
      992: {
        items: 4,
        stagePadding: 70
      }
    }
  });
  $("#bestseller_slider").owlCarousel({
    items: 1,
    margin: 30,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    smartSpeed: 800,
    dots: false,
    nav: false,
    navText: ["<i class='bi bi-chevron-left'></i>", "<i class='bi bi-chevron-right'></i>"],
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        stagePadding: 30
      },
      576: {
        items: 1,
        stagePadding: 80
      },
      768: {
        items: 3,
        stagePadding: 50
      },
      992: {
        items: 2,
        stagePadding: 50
      }
    }
  });
});
//navbar sticky on scroll
$(window).scroll(function () {
  if ($(this).scrollTop() > 152) {
    $('.nav_bar').addClass('sticky');
  } else {
    $('.nav_bar').removeClass('sticky');
  }
});
setTimeout(function () {
  $(".mobile_menu_wrap").show();
}, 2500);


  const wrapper = document.querySelector('.marquee_wrapper');
  const track = document.querySelector('.marquee_track');

  if (track && wrapper) {

    const imgs = track.querySelectorAll('img');
    let loaded = 0;

    function initMarquee() {
      if (!track.dataset.duplicated) {
        track.innerHTML += track.innerHTML;
        track.dataset.duplicated = "true";
      }
      const fullWidth = track.scrollWidth / 2;
      track.style.setProperty('--marquee-distance', `-${fullWidth}px`);
      let speed = 24;
      if (window.innerWidth <= 768) speed = Math.max(5, speed / 2);
      track.style.animationDuration = speed + "s";
    }

    if (imgs.length === 0) {
      initMarquee();
    } else {
      imgs.forEach(function(img) {
        if (img.complete) {
          loaded++;
          if (loaded === imgs.length) initMarquee();
        } else {
          img.onload = img.onerror = function() {
            loaded++;
            if (loaded === imgs.length) initMarquee();
          };
        }
      });
    }

    window.addEventListener('resize', initMarquee);

  }



jQuery('.fancybox').fancybox({
  baseClass: 'fancybox-custom-layout',
  infobar: false,
  hash: false,
  touch: {
    vertical: false,
  },
  buttons: ['close', 'slideShow'],
});
});


document.addEventListener('change', function(e) {

  if (!e.target.matches('.selling-plan-popup input[type="radio"]')) return;

  const form = e.target.closest('form');
  const hidden = form.querySelector('.selected-selling-plan');
  const qtyInput = form.querySelector('.product-card-quantity');

  if (hidden) hidden.value = e.target.value;

  if (qtyInput) {
    const planName = e.target.closest('label').textContent.trim();
    const match = planName.match(/^(\d+)/);
    qtyInput.value = match ? parseInt(match[1]) : 1;
  }
});

// PDP selling plan toggle: enable/disable quantity based on one-time vs subscription
function updatePdpQtyState(planValue) {
  var isSubscription = planValue !== '';
  var qtyWrapper = document.querySelector('.qty-subscription-wrapper');
  if (!qtyWrapper) return;
  var btns = qtyWrapper.querySelectorAll('.quantity__button');
  var input = qtyWrapper.querySelector('.quantity__input');
  if (isSubscription) {
    btns.forEach(function(b) { b.setAttribute('disabled', ''); });
    if (input) input.setAttribute('readonly', '');
  } else {
    btns.forEach(function(b) { b.removeAttribute('disabled'); });
    if (input) {
      input.removeAttribute('readonly');
      input.value = input.min || 1;
    }
  }
}

// Intercept the value property setter on the hidden selling_plan input
// so we catch programmatic changes from subscription apps
(function() {
  function hookSellingPlanInput() {
    var hiddenPlan = document.querySelector('input[name="selling_plan"]');
    if (!hiddenPlan || hiddenPlan._hooked) return;
    hiddenPlan._hooked = true;

    // Run once on load
    updatePdpQtyState(hiddenPlan.value);

    // Intercept value setter
    var descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    Object.defineProperty(hiddenPlan, 'value', {
      get: function() { return descriptor.get.call(this); },
      set: function(v) {
        descriptor.set.call(this, v);
        updatePdpQtyState(v);
      }
    });
  }

  // Also listen to change events (for native Shopify selling plan radios)
  document.addEventListener('change', function(e) {
    if (e.target.matches('[name="selling_plan"]')) {
      updatePdpQtyState(e.target.value);
    }
  });

  // Try immediately and after short delay (for app-rendered inputs)
  hookSellingPlanInput();
  setTimeout(hookSellingPlanInput, 500);
  setTimeout(hookSellingPlanInput, 1500);
})();

// Show toast when user clicks disabled quantity area (PDP)
document.addEventListener('click', function(e) {
  var wrapper = e.target.closest('.qty-subscription-wrapper');
  if (!wrapper) return;
  var btn = wrapper.querySelector('.quantity__button[disabled]');
  if (!btn) return;
  var toast = wrapper.querySelector('.qty-subscription-toast');
  if (!toast) return;
  toast.style.display = 'block';
  clearTimeout(wrapper._toastTimer);
  wrapper._toastTimer = setTimeout(function() { toast.style.display = 'none'; }, 3000);
});

// Show toast when user clicks disabled quantity area (cart drawer)
document.addEventListener('click', function(e) {
  var wrapper = e.target.closest('.cart-qty-subscription-wrapper');
  if (!wrapper) return;
  var toast = wrapper.querySelector('.qty-subscription-toast');
  if (!toast) return;
  toast.style.display = 'block';
  clearTimeout(wrapper._toastTimer);
  wrapper._toastTimer = setTimeout(function() { toast.style.display = 'none'; }, 3000);
});